import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-confirm-reverify-guest-dialog',
  imports: [
    CommonModule, 
    MatDialogModule, 
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './confirm-reverify-guest-dialog.component.html',
  styleUrl: './confirm-reverify-guest-dialog.component.scss'
})
export class ConfirmReverifyGuestDialogComponent {

  constructor(private dialogRef: MatDialogRef<ConfirmReverifyGuestDialogComponent>) { }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}